
export const MQTT_CHANNEL = "rhythm-dev/"
export const DOMAIN = "https://devrhythm.smartsight.in/api";
export const REPORT_DOMAIN = "https://devrhythm.smartsight.in/report-api";
export const MQTT_BROKER_URL = "wss://dev.theservitium.com:8883";
export const REPORT_EXPIRY_TIME = 60;
